import React from "react";

const ShareBar = () => {
  const currentUrl = window.location.href;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      alert("Link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const shareOn = (platform) => {
    const encodedUrl = encodeURIComponent(currentUrl);
    const text = encodeURIComponent("Check this out!");
    let shareUrl = "";

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "email":
        shareUrl = `mailto:?subject=Check this out&body=${encodedUrl}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${text}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="share-bar">
      <p className="share-bar__text">
        Like what you see? <strong>Share with a friend.</strong>
      </p>
      <div className="share-bar__actions">
        <button
          className="share-bar__button share-bar__button--copy"
          onClick={copyLink}
        >
          <img src="../assets/images/Blog/copy link.svg" alt="Copy Link" />
          Copy link
        </button>
        <button className="share-bar__icon" onClick={() => shareOn("facebook")}>
          <img src="../assets/images/Blog/facebook (1).svg" alt="Facebook" />
        </button>
        <button className="share-bar__icon" onClick={() => shareOn("email")}>
          <img src="../assets/images/Blog/twitter (1).svg" alt="Email" />
        </button>
        <button className="share-bar__icon" onClick={() => shareOn("linkedin")}>
          <img src="../assets/images/Blog/linkedin.svg" alt="LinkedIn" />
        </button>
      </div>
    </div>
  );
};

export default ShareBar;
